import AdvanceTableWrapper from "../common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "../common/advance-table/AdvanceTable";
import AdvanceTableFooter from "../common/advance-table/AdvanceTableFooter";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment-timezone";

import AdvanceTableSearchBox from "../common/advance-table/AdvanceTableSearchBox";
import PATH from "../../routes/RoutePath";
import useParamsHandler from "../../utils/hooks/useParamsHandler";

const UserListTable = ({
  archived,
  data,
  page,
  limit,
  totalCount,
  searchQuery,
  userTypeQuery,
  statusQuery,
}) => {
  const { searchParams, searchParamsHandler } = useParamsHandler();
  const column = searchParams.get("column") || "createdOn";
  const order = searchParams.get("order") || "desc";
  const sortHandler = (col, ord) => {
    // setPage(1);

    if (col === "createdOn") {
      ord === "asc" && searchParamsHandler("column", col, "order", "desc");
      // setSortQuery({
      //   column: column,
      //   order: "desc",
      // });
      ord === "desc" && searchParamsHandler("column", col, "order", "asc");
      // setSortQuery({
      //   column: column,
      //   order: "asc",
      // });
    } else {
      !ord && searchParamsHandler("column", col, "order", "asc");
      // setSortQuery({
      //   column: column,
      //   order: "asc",
      // });
      ord === "asc" && searchParamsHandler("column", col, "order", "desc");
      // setSortQuery({
      //   column: column,
      //   order: "desc",
      // });
      ord === "desc" && searchParamsHandler("column", col, "order", "asc");
      // setSortQuery({
      //   column: "createdOn",
      //   order: "desc",
      // });
    }
  };
  const columns = [
    {
      accessor: "displayName",
      Header: () => (
        <>
          Username{" "}
          <span
            className={`sort ${column === "displayName" && order}`}
            onClick={() => {
              sortHandler("displayName", column === "displayName" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { uid, displayName, userType } = rowData?.row.original;
        return (
          <>
            {uid && userType !== "admin" && userType !== "super-admin" ? (
              <Link to={uid ? PATH.USERS.USER_PROFILE + uid : "/"}>
                {displayName || "N/A"}
              </Link>
            ) : (
              displayName || "N/A"
            )}
          </>
        );
      },
    },
    {
      accessor: "userProfile",
      Header: () => (
        <>
          Full Name{" "}
          <span
            className={`sort ${column === "firstName" && order}`}
            onClick={() => {
              sortHandler("firstName", column === "firstName" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { userProfile } = rowData?.row.original;
        const fullName =
          userProfile?.firstName && userProfile?.lastName
            ? userProfile?.firstName + " " + userProfile?.lastName
            : "N/A";
        return <>{fullName}</>;
      },
    },
    {
      accessor: "email",
      Header: () => (
        <>
          Email{" "}
          <span
            className={`sort ${column === "email" && order}`}
            onClick={() => {
              sortHandler("email", column === "email" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { email } = rowData?.row.original;

        return <>{email || "N/A"}</>;
      },
    },
    {
      accessor: "userType",
      Header: () => (
        <>
          User Type{" "}
          <span
            className={`sort ${column === "userType" && order}`}
            onClick={() => {
              sortHandler("userType", column === "userType" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { userType } = rowData?.row.original;
        return (
          <>
            {(userType === "b-user" && "Business") ||
              (userType === "c-user" && "Charity") ||
              (userType === "g-user" && "General") ||
              (userType === "admin" && "Admin") ||
              (userType === "super-admin" && "Super Admin")}
          </>
        );
      },
    },
    {
      accessor: "status",
      Header: () => (
        <>
          Status{" "}
          <span
            className={`sort ${column === "status" && order}`}
            onClick={() => {
              sortHandler("status", column === "status" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { status } = rowData?.row.original;
        return <>{status || "Active"}</>;
      },
    },
    {
      accessor: "totalLovitz",
      Header: () => (
        <>
          Total Lovitz{" "}
          <span
            className={`sort ${column === "totalLovitz" && order}`}
            onClick={() => {
              sortHandler("totalLovitz", column === "totalLovitz" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { totalLovitz } = rowData?.row.original;
        return <>{totalLovitz || "N/A"}</>;
      },
    },
    {
      accessor: "createdOn",
      Header: () => (
        <>
          Created Date{" "}
          <span
            className={`sort ${column === "createdOn" && order}`}
            onClick={() => {
              sortHandler("createdOn", order);
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { createdOn } = rowData?.row.original;
        return (
          <>
            {createdOn
              ? moment(createdOn).tz("Australia/Brisbane").format("DD-MM-YYYY")
              : "N/A"}
          </>
        );
      },
    },
    {
      accessor: "lastLoginAt",
      Header: () => (
        <>
          Last Login Date{" "}
          <span
            className={`sort ${column === "lastLoginAt" && order}`}
            onClick={() => {
              sortHandler("lastLoginAt", column === "lastLoginAt" ? order : "");
            }}></span>
        </>
      ),
      disableSortBy: true,
      Cell: (rowData) => {
        const { lastLoginAt } = rowData?.row.original;
        return (
          <>{lastLoginAt ? moment(lastLoginAt).format("DD-MM-YYYY") : "N/A"}</>
        );
      },
    },
  ];
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data?.list || []}
      pagination
      perPage={data.limit}>
      <Row className="flex-end-center mb-3">
        <Col xs="auto" sm={10} lg={10}>
          <AdvanceTableSearchBox
            table
            filter={archived ? ["userType"] : ["userType", "status"]}
            searchQuery={searchQuery}
            userTypeQuery={userTypeQuery}
            statusQuery={statusQuery}
          />
        </Col>
      </Row>
      {data?.list?.length > 0 ? (
        <AdvanceTable
          table
          headerClassName="bg-200 text-900 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: "fs--1 mb-0 overflow-hidden",
          }}
        />
      ) : (
        <p>No {archived ? "Archived" : ""} Users Found</p>
      )}
      <div className="mt-3">
        <AdvanceTableFooter
          currentPage={page}
          limit={limit}
          rowCount={data?.limit}
          totalCount={totalCount}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
          pagination
        />
      </div>
    </AdvanceTableWrapper>
  );
};

export default UserListTable;
